import { useState, useEffect, useCallback } from "react";
import { fetchFilterOptions } from "../actions/overviewActions";
import { FilterOptions, OverviewFilterParam } from "../types/overview";

export const useFilters = (initialFilters: any = {}) => {
  const [filters, setFilters] = useState<any>(initialFilters);
  const [filterOptions, setFilterOptions] = useState<FilterOptions | null>(null);

  const fetchFilter = async () => {
    try {
      const response = await fetchFilterOptions();
      setFilterOptions(response);
    } catch (error) {
      console.error("Error fetching filter options:", error);
      setFilterOptions({
        countries: [],
        browsers: [],
        email_domains: [],
      });
    }
  };

  useEffect(() => {
    fetchFilter();
  }, []);

  const handleDateRangeChange = useCallback((dates: any, dateStrings: [string, string]) => {
    if (dates) {
      setFilters((prev: OverviewFilterParam) => ({
        ...prev,
        start_date: dateStrings[0],
        end_date: dateStrings[1],
      }));
    } else {
      setFilters((prev: OverviewFilterParam) => ({
        ...prev,
        start_date: undefined,
        end_date: undefined,
      }));
    }
  }, []);

  const handleFilterChange = useCallback((key: string, value: string) => {
    if (value === "all") {
      setFilters((prev: OverviewFilterParam) => ({
        ...prev,
        [key]: undefined,
      }));
    } else {
      setFilters((prev: OverviewFilterParam) => ({ ...prev, [key]: value }));
    }
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({});
  }, []);

  return {
    filters,
    filterOptions,
    handleDateRangeChange,
    handleFilterChange,
    resetFilters,
  };
};
